/*
 * yb-cart-ajax.js — Carrito AJAX + apertura del cajón para el tema (Shrine "nulled").
 * Este tema viene SIN product-form.js / cart-drawer.js / global.js, así que el
 * botón "Agregar al carrito" hacía un POST nativo a /cart. Este script:
 *   1. Intercepta el submit del formulario de producto y agrega por AJAX (/cart/add.js).
 *   2. Refresca el contenido del cajón vía Section Rendering API y lo ABRE (clase .active).
 *   3. Cablea cantidad (+/-/input) y eliminar dentro del cajón (/cart/change.js).
 * Degradación segura: ante cualquier error de red, hace fallback al submit nativo.
 */
(function () {
  'use strict';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function htmlInner(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector(selector);
      return node ? node.innerHTML : null;
    } catch (e) { return null; }
  }

  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var liveInner = document.querySelector('cart-drawer .cart-drawer');
      var fresh = htmlInner(sections['cart-drawer'], 'cart-drawer .cart-drawer');
      if (liveInner && fresh != null) liveInner.innerHTML = fresh;
      try {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var freshCd = doc.querySelector('cart-drawer');
        var cd = document.querySelector('cart-drawer');
        if (cd && freshCd) cd.classList.toggle('is-empty', freshCd.classList.contains('is-empty'));
      } catch (e) {}
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var b = htmlInner(sections['cart-icon-bubble'], '.shopify-section') || htmlInner(sections['cart-icon-bubble'], '#cart-icon-bubble');
      if (bubble && b != null) bubble.innerHTML = b;
    }
  }

  function getDrawer() { return document.querySelector('cart-drawer'); }
  function openDrawer() {
    var d = getDrawer(); if (!d) return;
    d.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }
  function closeDrawer() {
    var d = getDrawer(); if (!d) return;
    d.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  function changeLine(line, quantity) {
    if (line == null) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: quantity,
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); })
      .then(function (d) { applySections(d && d.sections); })
      .catch(function () {});
  }

  /* Custom elements ausentes en el tema nulled */
  if (!customElements.get('cart-drawer')) {
    try {
      customElements.define('cart-drawer', class extends HTMLElement {
        open() { openDrawer(); }
        close() { closeDrawer(); }
        renderContents(parsed) { if (parsed && parsed.sections) applySections(parsed.sections); openDrawer(); }
      });
    } catch (e) {}
  }
  if (!customElements.get('cart-remove-button')) {
    try {
      customElements.define('cart-remove-button', class extends HTMLElement {
        constructor() {
          super();
          var self = this;
          this.addEventListener('click', function (e) {
            e.preventDefault();
            changeLine(self.getAttribute('data-index'), 0);
          });
        }
      });
    } catch (e) {}
  }

  function setBusy(form, on) {
    var btn = form.querySelector('[name="add"], [type="submit"]');
    if (!btn) return;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); }
    else { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); }
  }

  /* 1) Interceptar agregar al carrito */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    setBusy(form, true);
    var fd = new FormData(form);
    // Bundle nativo: si hay un paquete seleccionado, forzar su variante (en escritorio hay 2 forms con input[name=id]).
    var ybSel = document.querySelector('.yb-bar.is-sel[data-vid]');
    if (ybSel && form.querySelector('input[name="id"]')) { fd.set('id', ybSel.getAttribute('data-vid')); }
    fd.append('sections', SECTIONS);
    fd.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) { form.submit(); return; }
        applySections(res.data && res.data.sections);
        openDrawer();
      })
      .catch(function () { try { form.submit(); } catch (e) {} })
      .finally(function () { setBusy(form, false); });
  }, true);

  /* 2) Cantidad (+/-) y cerrar por overlay (delegado) */
  document.addEventListener('click', function (e) {
    if (e.target && (e.target.id === 'CartDrawer-Overlay' || (e.target.closest && e.target.closest('.drawer__close')))) {
      closeDrawer();
      return;
    }
    var qbtn = e.target.closest ? e.target.closest('.quantity__button') : null;
    if (qbtn && qbtn.closest('cart-drawer')) {
      e.preventDefault();
      var qi = qbtn.parentNode.querySelector('.quantity__input');
      if (!qi) return;
      var step = parseInt(qi.getAttribute('step') || '1', 10) || 1;
      var cur = parseInt(qi.value || '1', 10) || 1;
      var min = parseInt(qi.getAttribute('min') || '0', 10);
      var max = qi.getAttribute('max') ? parseInt(qi.getAttribute('max'), 10) : null;
      var next = qbtn.name === 'plus' ? cur + step : cur - step;
      if (next < min) next = min;
      if (max != null && next > max) next = max;
      changeLine(qi.getAttribute('data-index'), next);
    }
  });

  /* 3) Cambio directo del input de cantidad */
  document.addEventListener('change', function (e) {
    var qi = e.target;
    if (qi && qi.classList && qi.classList.contains('quantity__input') && qi.closest && qi.closest('cart-drawer')) {
      changeLine(qi.getAttribute('data-index'), parseInt(qi.value || '1', 10) || 1);
    }
  });

  /* ESC cierra */
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeDrawer(); });
})();
